import type { BoxProps } from '@hover/blueprint';

import type { PaymentBanner } from 'src/shared/graphql/generated';

interface PaymentBannerProps extends BoxProps {
  details: Omit<PaymentBanner, 'daysRemaining'>;
}

const PAYMENT_BANNER_EVENT_NAMES = {
  TRIAL: 'Trial',
  EXPIRING: 'Expiring-trial',
  EXPIRED: 'Post-trial',
};

export { PaymentBannerProps, PAYMENT_BANNER_EVENT_NAMES };
